import { getTeamUrl } from 'Common';

export default (options) => async (dispatch, getState) => {

  const key = options.key;
  const parts = key.split('-');
  const format = parts[parts.length - 1]; // 'excel' or 'csv'

  const { searchTerm, filters, sorting } = getState().screens.Projects;

  const params = {};

  if (sorting.columnKey) {
    params.csort = (sorting.order === 'descend' ? '-' : '') + sorting.columnKey;
  }

  if (searchTerm) {
    params.search = searchTerm;
  }

  if (filters.status_key !== 'all') {
    params['filter[status_key]'] = filters.status_key;
  }

  if (filters.phase_key.length > 0) {
    params['filter[phase_key]'] = filters.phase_key.join(',');
  }

  if (filters.client_id.length > 0) {
    params['filter[client_id]'] = filters.client_id.join(',');
  }

  if (filters.contracts_manager.length > 0) {
    params['filter[contracts_manager]'] = filters.contracts_manager.join(',');
  }

  if (filters.supervisor_id.length > 0) {
    params['filter[supervisor_id]'] = filters.supervisor_id.join(',');
  }

  if (filters.no_start_handover_date) {
    params['filter[no_start_handover_date]'] = 1
  }

  let endpoint;
  if (key.startsWith('valuation-dates')) {
    endpoint = 'valuation_dates/export';
  } else {
    endpoint = 'projects/export';
  }

  let url = `${endpoint}?type=${format}`;

  Object.keys(params).forEach(key => {
    if (params[key]) url += `&${key}=${params[key]}`
  })

  window.location = getTeamUrl(url, 'exports');

}
